import * as Yup from "yup";

export const AppointmentSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(1, "Name is required"),
  duration: Yup.number().required("Duration is required"),
  price: Yup.number("Only number allowed for price"),
  description: Yup.string(),
  trainers: Yup.array().min(1, "Please assign trainers"),
  allowOnlineBooking: Yup.boolean(),
  allowCancelation: Yup.boolean(),
  allowUnpaidBooking: Yup.boolean(),
  noShowDeduction: Yup.boolean(),
  packages: Yup.array().required("Please assign this appointment to packages"),
});

export const days = [
  {
    key: 0,
    label: "Su",
    value: "sun",
  },
  {
    key: 1,
    label: "Mo",
    value: "mon",
  },
  {
    key: 2,
    label: "Tu",
    value: "tue",
  },
  {
    key: 3,
    label: "We",
    value: "wed",
  },
  {
    key: 4,
    label: "Th",
    value: "thu",
  },
  {
    key: 5,
    label: "Fr",
    value: "fri",
  },
  {
    key: 6,
    label: "Sa",
    value: "sat",
  },
];
const colourStyles = {
  control: (styles, { isFocused }) => ({
    backgroundColor: "white",
    width: "100%",
    height: "auto",
    boxShadow: "none",
    padding: "8px 0px",
    cursor: "text",
    borderRadius: "4px",
    transition: "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "white" : "white",
      color: "black",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "purple",
        color: "white",
      },
    };
  },
};

export const customStyle = {
  control: (styles, { isFocused }) => ({
    ...styles,
    backgroundColor: "white",
    width: "100%",
    height: "auto",
    boxShadow: "none",
    padding: "8px 0px",
    cursor: "text",
    borderRadius: "4px",
    transition: "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "white" : "white",
      color: "black",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "purple",
        color: "white",
      },
    };
  },
};

export const timesArr = [
  { time: "6:00 AM", value: "6:00" },
  { time: "6:30 AM", value: "6:30" },
  { time: "7:00 AM", value: "7:00" },
  { time: "7:30 AM", value: "7:30" },
  { time: "8:00 AM", value: "8:00" },
  { time: "8:30 AM", value: "8:30" },
  { time: "9:00 AM", value: "9:00" },
  { time: "9:30 AM", value: "9:30" },
  { time: "10:00 AM", value: "10:00" },
  { time: "10:30 AM", value: "10:30" },
  { time: "11:00 AM", value: "11:00" },
  { time: "11:30 AM", value: "11:30" },
  { time: "12:00 PM", value: "12:00" },
  { time: "12:30 PM", value: "12:30" },
  { time: "1:00 PM", value: "13:00" },
  { time: "1:30 PM", value: "13:30" },
  { time: "2:00 PM", value: "14:00" },
  { time: "2:30 PM", value: "14:30" },
  { time: "3:00 PM", value: "15:00" },
  { time: "3:30 PM", value: "15:30" },
  { time: "4:00 PM", value: "16:00" },
  { time: "4:30 PM", value: "16:30" },
  { time: "5:00 PM", value: "17:00" },
  { time: "5:30 PM", value: "17:30" },
  { time: "6:00 PM", value: "18:00" },
  { time: "6:30 PM", value: "18:30" },
  { time: "7:00 PM", value: "19:00" },
  { time: "7:30 PM", value: "19:30" },
  { time: "8:00 PM", value: "20:00" },
  { time: "8:30 PM", value: "20:30" },
  { time: "9:00 PM", value: "21:00" },
  { time: "9:30 PM", value: "21:30" },
  { time: "10:00 PM", value: "22:00" },
  { time: "10:30 PM", value: "22:30" },
  { time: "11:00 PM", value: "23:00" },
  { time: "11:30 PM", value: "23:30" },
  { time: "12:00 AM", value: "00:00" },
  { time: "12:30 AM", value: "00:30" },
  { time: "1:00 AM", value: "1:00" },
  { time: "1:30 AM", value: "1:30" },
  { time: "2:00 AM", value: "2:00" },
  { time: "2:30 AM", value: "2:30" },
  { time: "3:00 AM", value: "3:00" },
  { time: "3:30 AM", value: "3:30" },
  { time: "4:00 AM", value: "4:00" },
  { time: "4:30 AM", value: "4:30" },
  { time: "5:00 AM", value: "5:00" },
  { time: "5:30 AM", value: "5:30" },
];

export const defaultSettings = [
  {
    key: "allowOnlineBooking",
    label: "Allow Online Bookings",
  },
  {
    key: "allowCancelation",
    label: "Allow consumer to cancel.",
  },
  {
    key: "allowUnpaidBooking",
    label: "Allow online booking if unpaid",
  },
  {
    key: "noShowDeduction",
    label: "Deduct no show/late cancelation from package.",
  },
];

export const checkIfAlreadyExist = (data, id, checkForId = false) => {
  let found = false;
  data.forEach((item, idx) => {
    console.log({ checkForId }, { item });
    if (!checkForId && item.value === id) found = true;
    if (checkForId && item.id === id) found = true;
  });
  return found;
};

export const gateTypes = [
  {
    key: "GYM",
    label: "GYM",
  },
  {
    key: "Pool",
    label: "Pool",
  },
  {
    key: "Studio",
    label: "Studio",
  }
];

export const weekDays = [
  {
    value: "sat",
    label: "Saturday",
  },
  {
    value: "sun",
    label: "Sunday",
  },
  {
    value: "mon",
    label: "Monday",
  },
  {
    value: "tue",
    label: "Tuesday",
  },
  {
    value: "wed",
    label: "Wednesday",
  },
  {
    value: "thu",
    label: "Thursday",
  },
  {
    value: "fri",
    label: "Friday",
  },
];